import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { PharmaIndustryPageBG } from "@/components/site/PharmaIndustryPageBG";
import { PHARMA_META_DESCRIPTION_BG } from "@/content/meta/PharmaIndustryPageBG";

import { pageSchemas } from "@/lib/seo/page-schema";
export const Route = createFileRoute("/bg/industries/pharma")({
  head: () => ({
    meta: [
      { title: "Медиен мониторинг и анализи за фарма | Perceptica" },
      { name: "description", content: PHARMA_META_DESCRIPTION_BG },

      { property: "og:title", content: "Медиен мониторинг и анализи за фарма | Perceptica" },
      { property: "og:description", content: PHARMA_META_DESCRIPTION_BG },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Медиен мониторинг и анализи за фарма | Perceptica" },
      { name: "twitter:description", content: PHARMA_META_DESCRIPTION_BG },
      { property: "og:url", content: "https://perceptica.com/bg/industries/pharma" },
      ...ogImageMeta("bg", "/industries/pharma"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "bg", path: "/industries/pharma" }),
  }),
  component: PharmaIndustryPageBG,
});
